import React from "react";
import Navbar from "../../../Navbar/Navbar";
import FormMandub from "./FormMandub";
import swal from "sweetalert";

class Mandub extends React.Component {
  constructor() {
    super();
    this.state = {
      savekrdn: false
    };
  }

  onSaveChange = (
    MM_nawebarez,
    MM_zhmaraybarez,
    MM_wasleShareka,
    MM_nawewargr,
    MM_brepara,
    MM_joredraw,
    MM_note
  ) => {
    if (
      MM_nawebarez == "" ||
      MM_zhmaraybarez == 0 ||
      MM_wasleShareka == 0 ||
      MM_nawewargr == null ||
      MM_brepara == 0 ||
      MM_brepara == "" ||
      MM_joredraw == null ||
      MM_note.toString().length == 0
    ) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      this.setState({
        savekrdn: true
      });
      swal({
        title: "تەواو",
        text: "پسولە سورکەوتوو بوو!",
        icon: "success",
        timer: 2000
      });
    }
  };

  onNewPage = () => {
    this.setState({
      savekrdn: false
    });
  };
  render() {
    return (
      <>
        <Navbar />
        <div className="mt5"></div>
        <FormMandub
          onNewPage={this.onNewPage}
          onSaveChange={this.onSaveChange}
          savekrdn={this.state.savekrdn}
        />
      </>
    );
  }
}

export default Mandub;
